import { useState } from 'react';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {
    updateArrivalDate,
    updateReturnDate,
} from "../../redux/searchBoxSlice";
import { useDispatch } from "react-redux";
import useTranslation from "next-translate/useTranslation";

function ButtonField(props) {
    const {
        setOpen,
        label,
        id,
        disabled,
        InputProps: { ref } = {},
        inputProps: { 'aria-label': ariaLabel } = {},
    } = props;

    return (
        <Button
            variant="outlined"
            id={id}
            className='!text-jacarta-700 dark:!text-white !bg-jacarta-100 dark:!bg-jacarta-700 !border-0 !hover:border-0 !hover-rounded-lg h-[48px]'
            disabled={disabled}
            ref={ref}
            aria-label={ariaLabel}
            onClick={() => setOpen?.((prev) => !prev)}
        >
            {label ?? 'Pick a date'}
        </Button>
    );
}

function ButtonDatePicker(props, { minDate }) {
    const [open, setOpen] = useState(false);
    return (
        <DatePicker
            disablePast={true}
            slots={{ field: ButtonField, ...props.slots }}
            slotProps={{ field: { setOpen } }}
            {...props}
            sx={[{ "& .MuiInputBase-root": { background: "#E7E8EC" } }]}
            open={open}
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
        />
    );
}
export default function CustomDatePicker({ destinationKey, setDirection, minDate }) {
    const { t } = useTranslation("book");
    const [value, setValue] = useState(null);
    const dispatch = useDispatch();

    const updateStoreDates = (value) => {
        destinationKey === "arrival"
            ? dispatch(updateArrivalDate(value.format("DD/MM/YYYY")))
            : dispatch(updateReturnDate(value.format("DD/MM/YYYY")))
    }

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <Stack spacing={1}>
                <ButtonDatePicker
                    label={`${t(destinationKey)} ${value == null ? '-----' : value.format('DD/MM/YYYY')
                        }`}
                    value={value}
                    onChange={(newValue) => {
                        setValue(newValue);
                        setDirection(newValue);
                        updateStoreDates(newValue);
                    }
                    }
                    minDate={minDate}
                />
            </Stack>
        </LocalizationProvider>
    );
}